
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { RequestTypeDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';
@Component({
  selector: 'cradua-requesttype-container',
  templateUrl: './requesttype-container.component.html',
  styleUrls: ['./requesttype-container.component.scss']
})
export class RequesttypeContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  requestTypes$: Observable<RequestTypeDto[]>;
  loading: boolean;
  isLoadingRequestType$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingRequestType$ = this.gatwayFacade.isLoadingGateway("RequestType");
    this.requestTypes$ = this.gatwayFacade.loadGateway("RequestType");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteRequestType(deletedValue: any) {
    this.gatwayFacade.remove("RequestType", deletedValue);
  }


// this method control both the create and update

  onSubmitRequestType(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.RequestTypes;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllRequestType = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllRequestType.push(pullData[i]);
    }
  }

// check if the addAllRequestType array is not empty, then dispatch the data to the store
   if(addAllRequestType.length > 0) {
    this.gatwayFacade.add('RequestType', addAllRequestType);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('RequestType', allUpdates, ['id']);
  }

   }

}
